var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.58065 0C10.215 0 13.1613 2.94626 13.1613 6.58065C13.1613 8.00146 12.711 9.31711 11.9454 10.3927L16.6788 15.1277C17.1071 15.556 17.1071 16.2504 16.6788 16.6788C16.2834 17.0741 15.6613 17.1045 15.231 16.77L15.1277 16.6788L10.3927 11.9454C9.31711 12.711 8.00146 13.1613 6.58065 13.1613C2.94626 13.1613 0 10.215 0 6.58065C0 2.94626 2.94626 0 6.58065 0ZM6.58065 2.19355C4.15772 2.19355 2.19355 4.15772 2.19355 6.58065C2.19355 9.00357 4.15772 10.9677 6.58065 10.9677C9.00357 10.9677 10.9677 9.00357 10.9677 6.58065C10.9677 4.15772 9.00357 2.19355 6.58065 2.19355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.325a840f1c9fb3f124fbc47e10a472e2.svg";
export { ForwardRef as ReactComponent };